var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _path7, _path8, _path9, _path10, _path11, _path12, _rect5, _rect6, _path13, _path14, _path15, _path16, _path17, _path18, _rect7, _rect8, _path19, _path20, _path21, _path22, _path23, _path24, _rect9, _rect10, _path25, _path26, _path27, _path28, _path29, _path30, _rect11, _rect12, _path31, _path32, _path33, _path34, _path35, _path36, _rect13, _rect14, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect15, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveSmokingCessation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 146,
    viewBox: "0 0 276 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157.418,
    y: 1.12944,
    width: 38,
    height: 38,
    rx: 19,
    transform: "rotate(8 157.418 1.12944)",
    fill: "#D7512D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.418,
    y: 1.12944,
    width: 38,
    height: 38,
    rx: 19,
    transform: "rotate(8 157.418 1.12944)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.836 20.5489C161.895 20.1282 162.284 19.835 162.705 19.8942L166.895 20.483C167.105 20.5125 167.252 20.707 167.222 20.9174L166.687 24.7261C166.657 24.9364 166.463 25.083 166.252 25.0534L162.063 24.4646C161.642 24.4055 161.349 24.0165 161.408 23.5958L161.836 20.5489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.829 24.8859L168.364 21.0772C168.394 20.8668 168.588 20.7203 168.799 20.7498L171.307 21.1023C171.408 21.1165 171.499 21.1703 171.561 21.2517L174.834 25.5958C175.04 25.8694 174.813 26.2558 174.474 26.2081L168.157 25.3203C167.946 25.2907 167.8 25.0962 167.829 24.8859Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.688 23.7606L184.259 26.8076C184.2 27.2283 183.811 27.5214 183.391 27.4623L178.755 26.8108C178.553 26.7824 178.37 26.6749 178.248 26.5119L175.07 22.2952C174.864 22.0215 175.091 21.6351 175.431 21.6828L184.033 22.8918C184.454 22.9509 184.747 23.3399 184.688 23.7606Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.634 14.6789L183.266 15.354C182.843 16.1322 182.845 17.0726 183.273 17.8485V17.8485C183.625 18.4857 183.692 19.2412 183.46 19.9308L183.158 20.8264",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.26 13.8166L179.892 14.4917C179.469 15.2699 179.471 16.2103 179.899 16.9862V16.9862C180.25 17.6234 180.318 18.3789 180.086 19.0685L179.784 19.9641",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.263 11.5684L179.321 31.5508",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.83,
    y: 30.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 168.83 30.8706)",
    fill: "#D7512D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.83,
    y: 30.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 168.83 30.8706)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.003 56.6582C176.074 56.1534 176.541 55.8017 177.046 55.8726L182.073 56.5792C182.326 56.6147 182.502 56.848 182.466 57.1005L181.824 61.6709C181.788 61.9233 181.555 62.0992 181.303 62.0637L176.275 61.3572C175.77 61.2862 175.419 60.8194 175.489 60.3146L176.003 56.6582Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.195 61.8635L183.837 57.293C183.873 57.0406 184.106 56.8647 184.358 56.9002L187.368 57.3232C187.49 57.3402 187.599 57.4047 187.673 57.5025L191.601 62.7153C191.848 63.0437 191.575 63.5073 191.168 63.4501L183.588 62.3847C183.335 62.3493 183.159 62.1159 183.195 61.8635Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.426 60.5125L202.912 64.1689C202.841 64.6738 202.374 65.0255 201.869 64.9545L196.306 64.1727C196.064 64.1386 195.845 64.0097 195.697 63.8141L191.884 58.754C191.637 58.4256 191.91 57.962 192.317 58.0192L202.64 59.47C203.145 59.5409 203.496 60.0077 203.426 60.5125Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.161 49.6144L201.72 50.4247C201.211 51.3585 201.214 52.487 201.728 53.418V53.418C202.149 54.1827 202.231 55.0892 201.952 55.9168L201.59 56.9914",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.112 48.5793L197.671 49.3895C197.163 50.3233 197.166 51.4518 197.679 52.3828V52.3828C198.101 53.1475 198.182 54.0541 197.903 54.8816L197.541 55.9563",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.915 45.8818L196.984 69.8607",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5543,
    y: 24.6168,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-6 32.5543 24.6168)",
    fill: "#D7512D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5543,
    y: 24.6168,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-6 32.5543 24.6168)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7698 51.6355C47.7076 51.044 48.1367 50.5141 48.7283 50.4519L54.6189 49.8328C54.9146 49.8017 55.1796 50.0162 55.2107 50.312L55.7735 55.6671C55.8046 55.9629 55.5901 56.2278 55.2943 56.2589L49.4037 56.878C48.8122 56.9402 48.2822 56.5111 48.2201 55.9196L47.7698 51.6355Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3799 55.499L56.817 50.1439C56.7859 49.8482 57.0005 49.5832 57.2963 49.5521L60.823 49.1814C60.965 49.1665 61.1072 49.2086 61.2182 49.2985L67.1361 54.0908C67.5089 54.3927 67.3306 54.9946 66.8536 55.0447L57.9717 55.9783C57.6759 56.0093 57.411 55.7948 57.3799 55.499Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9 48.2591L80.3503 52.5432C80.4125 53.1347 79.9834 53.6647 79.3919 53.7268L72.8738 54.4119C72.5898 54.4418 72.3055 54.3575 72.0835 54.1778L66.3389 49.5259C65.9661 49.224 66.1444 48.6221 66.6215 48.5719L78.7165 47.3007C79.308 47.2385 79.8379 47.6676 79.9 48.2591Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3927 36.2797L75.1222 37.3214C74.8105 38.5219 75.1325 39.7985 75.9763 40.7075V40.7075C76.6694 41.4542 77.0174 42.4575 76.9353 43.4729L76.8287 44.7916",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5167 36.2504L70.2462 37.2921C69.9345 38.4926 70.2565 39.7692 71.1004 40.6782V40.6782C71.7935 41.4249 72.1414 42.4282 72.0593 43.4436L71.9528 44.7623",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0254 38.6152L75.248 60.6597",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80.9166,
    y: 7.27455,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 80.9166 7.27455)",
    fill: "#D7512D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80.9166,
    y: 7.27455,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 80.9166 7.27455)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7064 30.7877C93.662 30.2799 94.0377 29.8321 94.5455 29.7877L99.6031 29.3452C99.8571 29.323 100.081 29.5109 100.103 29.7648L100.505 34.3626C100.528 34.6165 100.34 34.8404 100.086 34.8626L95.0283 35.3051C94.5204 35.3495 94.0727 34.9738 94.0282 34.466L93.7064 30.7877Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.885 34.2422L101.483 29.6444C101.46 29.3904 101.648 29.1666 101.902 29.1443L104.93 28.8794C105.052 28.8688 105.173 28.907 105.267 28.9856L110.267 33.1812C110.582 33.4455 110.42 33.9587 110.011 33.9946L102.385 34.6617C102.131 34.6839 101.907 34.4961 101.885 34.2422Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.294 28.3739L121.616 32.0521C121.66 32.56 121.285 33.0077 120.777 33.0521L115.18 33.5417C114.937 33.5631 114.694 33.4867 114.507 33.3293L109.653 29.2566C109.338 28.9923 109.5 28.4791 109.909 28.4433L120.294 27.5347C120.802 27.4903 121.25 27.866 121.294 28.3739Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.61 18.0403L117.362 18.929C117.077 19.9532 117.334 21.0521 118.044 21.8437V21.8437C118.626 22.494 118.91 23.359 118.824 24.2281L118.713 25.3566",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.432 17.9427L113.185 18.8313C112.899 19.8555 113.156 20.9544 113.866 21.7461V21.7461C114.449 22.3963 114.732 23.2614 114.646 24.1304L114.535 25.259",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1211 19.6328L117.121 38.9324",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 126.34,
    y: 24.1441,
    width: 46,
    height: 46,
    rx: 23,
    transform: "rotate(9 126.34 24.1441)",
    fill: "#D7512D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 126.34,
    y: 24.1441,
    width: 46,
    height: 46,
    rx: 23,
    transform: "rotate(9 126.34 24.1441)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 47.7652C131.479 47.2617 131.952 46.9182 132.456 46.9979L137.47 47.7921C137.722 47.832 137.894 48.0684 137.854 48.3202L137.132 52.8787C137.092 53.1305 136.855 53.3023 136.604 53.2624L131.589 52.4682C131.086 52.3884 130.742 51.9156 130.822 51.4121L131.4 47.7652Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 53.0945L139.222 48.5359C139.262 48.2842 139.498 48.1124 139.75 48.1523L142.752 48.6278C142.873 48.6469 142.981 48.7133 143.053 48.8123L146.89 54.0929C147.131 54.4256 146.85 54.8844 146.444 54.8201L138.883 53.6226C138.632 53.5827 138.46 53.3463 138.5 53.0945Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158.75 52.0967L158.173 55.7436C158.093 56.2471 157.62 56.5906 157.117 56.5109L151.568 55.6321C151.326 55.5938 151.11 55.461 150.966 55.2629L147.242 50.137C147 49.8044 147.281 49.3456 147.687 49.4099L157.983 51.0406C158.487 51.1203 158.83 51.5932 158.75 52.0967Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M157.676 41.1791L157.221 41.9815C156.697 42.9063 156.68 44.0347 157.177 44.9745V44.9745C157.585 45.7464 157.651 46.6543 157.358 47.4768L156.977 48.545",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.646 40.0736L153.191 40.876C152.666 41.8008 152.65 42.9292 153.147 43.869V43.869C153.555 44.641 153.62 45.5488 153.327 46.3713L152.946 47.4395",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 37.041L152.148 61.3316",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9327,
    y: 54.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 75.9327 54.9784)",
    fill: "#D7512D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9327,
    y: 54.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 75.9327 54.9784)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1962 82.5118C90.1547 81.9185 90.6021 81.4039 91.1954 81.3624L97.104 80.9492C97.4007 80.9285 97.658 81.1521 97.6788 81.4488L98.0544 86.8203C98.0751 87.117 97.8514 87.3743 97.5548 87.395L91.6461 87.8082C91.0528 87.8497 90.5382 87.4023 90.4967 86.809L90.1962 82.5118Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6651 86.7075L99.2895 81.336C99.2688 81.0393 99.4924 80.782 99.7891 80.7613L103.327 80.5139C103.469 80.5039 103.61 80.551 103.717 80.6447L109.465 85.6406C109.827 85.9553 109.627 86.5506 109.149 86.5841L100.24 87.2071C99.9432 87.2278 99.6859 87.0041 99.6651 86.7075Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 80.2584L122.725 84.5556C122.766 85.1489 122.319 85.6635 121.726 85.705L115.188 86.1622C114.903 86.1821 114.621 86.088 114.406 85.9006L108.827 81.0511C108.465 80.7364 108.664 80.141 109.143 80.1076L121.275 79.2592C121.868 79.2177 122.383 79.6651 122.424 80.2584Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.338 68.1292L118.032 69.1607C117.678 70.3496 117.956 71.6367 118.767 72.5746V72.5746C119.434 73.345 119.746 74.3598 119.629 75.3718L119.477 76.686",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.466 67.9299L113.16 68.9615C112.806 70.1504 113.083 71.4375 113.895 72.3754V72.3754C114.562 73.1458 114.874 74.1606 114.757 75.1726L114.604 76.4868",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9062 69.5078L117.343 92.4889",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 127.978,
    y: 65.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 127.978 65.9327)",
    fill: "#D7512D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 127.978,
    y: 65.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 127.978 65.9327)",
    stroke: "#F3EADD",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.271 95.1837C138.312 94.5904 138.827 94.143 139.42 94.1845L145.329 94.5977C145.625 94.6184 145.849 94.8757 145.828 95.1724L145.453 100.544C145.432 100.841 145.175 101.064 144.878 101.043L138.969 100.63C138.376 100.589 137.929 100.074 137.97 99.4809L138.271 95.1837Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.064 100.657L147.44 95.2852C147.461 94.9885 147.718 94.7649 148.015 94.7856L151.552 95.033C151.695 95.0429 151.827 95.1091 151.921 95.2169L156.917 100.964C157.232 101.326 156.952 101.888 156.473 101.854L147.564 101.231C147.267 101.211 147.044 100.953 147.064 100.657Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 97.4371L170.199 101.734C170.158 102.328 169.643 102.775 169.05 102.733L162.512 102.276C162.227 102.256 161.962 102.124 161.774 101.909L156.925 96.3297C156.61 95.9677 156.89 95.4059 157.369 95.4393L169.5 96.2877C170.094 96.3292 170.541 96.8438 170.5 97.4371Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.141 84.8568L167.694 85.8357C167.178 86.9638 167.274 88.2769 167.947 89.3187V89.3187C168.5 90.1744 168.668 91.2228 168.411 92.2086L168.077 93.4888",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.344 83.9818L162.897 84.9607C162.381 86.0888 162.477 87.4019 163.15 88.4437V88.4437C163.703 89.2994 163.871 90.3478 163.614 91.3336L163.28 92.6138",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.784 82.4043L163.765 108.841",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 88C52 86.8954 52.8954 86 54 86H74.2654C75.2607 86 76.1046 86.7319 76.2453 87.7172L79.7547 112.283C79.8954 113.268 80.7393 114 81.7346 114H182.265C183.261 114 184.105 113.268 184.245 112.283L187.755 87.7172C187.895 86.7319 188.739 86 189.735 86H210C211.105 86 212 86.8954 212 88V114V140C212 141.105 211.105 142 210 142H180H84H54C52.8954 142 52 141.105 52 140V114V88Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 42.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.5,
    cy: 47.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 24 146)",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M215 21.5L234 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5L27 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 79.5L5.5 87",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M232 71L247.5 73.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveSmokingCessation);
export default __webpack_public_path__ + "static/media/collective-smoking-cessation.53ce9109783bdf186f832d2751252f9d.svg";
export { ForwardRef as ReactComponent };